"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ClientRequest_1 = __importDefault(require("../ClientRequest"));
const BasicApi = {
    getFollowHashtags: async (page) => {
        const res = await ClientRequest_1.default.get(`hash-tag-follows?page=${page}&per_page=8`);
        return res.data;
    },
    followHashtag: async (hashtagId) => {
        const res = await ClientRequest_1.default.post(`hash-tags/${hashtagId}/follows`);
        return res.data;
    },
    unfollowHashtag: async (hashtagId) => {
        const res = await ClientRequest_1.default.delete(`hash-tags/${hashtagId}/follows`);
        return res.data;
    },
    getFollowUser: async (page, userId) => {
        const res = await ClientRequest_1.default.get(`user-follows/${userId}?page=${page}&per_page=16`);
        return res.data;
    },
    getFollowerUser: async (page, userId) => {
        const res = await ClientRequest_1.default.get(`user-followers/${userId}?page=${page}&per_page=16`);
        return res.data;
    },
    followUser: async (userId) => {
        const res = await ClientRequest_1.default.post(`users/${userId}/follows`);
        return res.data;
    },
    unfollowUser: async (userId) => {
        const res = await ClientRequest_1.default.delete(`users/${userId}/follows`);
        return res.data;
    },
    blockUser: async (userId) => {
        const res = await ClientRequest_1.default.post(`users/${userId}/blocks`);
        return res.data;
    },
    unblockUser: async (userId) => {
        const res = await ClientRequest_1.default.delete(`users/${userId}/blocks`);
        return res.data;
    },
    muteUser: async (userId) => {
        const res = await ClientRequest_1.default.post(`users/${userId}/mutes`);
        return res.data;
    },
    unMuteUser: async (userId) => {
        const res = await ClientRequest_1.default.delete(`users/${userId}/mutes`);
        return res.data;
    },
    followHashTag: async (data) => {
        const res = await ClientRequest_1.default.post(`hash-tags/${data}/follows`);
        return res.data;
    },
    unFollowHashTag: async (data) => {
        const res = await ClientRequest_1.default.delete(`hash-tags/${data}/follows`);
        return res.data;
    },
    editFollowHashtag: async (hashtagId, is_private) => {
        const res = await ClientRequest_1.default.patch(`hash-tag-follows?hash_tag_id=${hashtagId}&is_private=${is_private}`);
        return res.data;
    },
};
exports.default = BasicApi;
